import React, { useContext } from 'react';
import styled from 'styled-components';

// Context
import { Context } from '../context/GlobalContext';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  background-color: ${props => props.theme.colors.green};
  color: ${props => props.theme.colors.white};
  align-items: center;
  justify-content: center;
`;

const MessageBox = () => {
  const { message } = useContext(Context);

  return message && <Container>{message}</Container>;
};

export default MessageBox;
